export const TAG_COLOR_PALETTE = [
  '#ef4444',
  '#f97316',
  '#eab308',
  '#22c55e',
  '#14b8a6',
  '#3b82f6',
  '#8b5cf6',
  '#ec4899',
  '#94a3b8',
];

export const DEFAULT_TAG_COLOR = '#8b5cf6';
